import { render, staticRenderFns } from "./MenahalNewBroadcast.vue?vue&type=template&id=6de72a3b&"
import script from "./MenahalNewBroadcast.vue?vue&type=script&lang=js&"
export * from "./MenahalNewBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./MenahalNewBroadcast.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports